"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPlaySolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M7.891 21.736l14.135-8.128c.429-.235.716-.56.864-.977a1.825 1.825 0 000-1.25c-.148-.417-.435-.743-.864-.977L7.891 2.275a1.796 1.796 0 00-1.245-.254 1.99 1.99 0 00-1.164.586C5.16 2.933 5 3.357 5 3.877v16.257c0 .469.154.873.462 1.211.308.34.69.548 1.144.626.455.078.884 0 1.285-.235z"
  }));
}

var _default = SvgPlaySolid;
exports.default = _default;